import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'home',
    component: Home,
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/',
    name: 'home2',
    component: Home,
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/home',
    name: 'home3',
    component: Home,
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/community',
    name: 'community',
    component: () => import('../views/Community.vue'),
  }, {
    path: '/articlelist/:title',
    name: 'articlelist',
    component: () => import('../views/ArticleList.vue'),
  },  
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/Shop.vue'),
  }, {
    path: '/service',
    name: 'service',
    component: () => import('../views/Service.vue'),
  }, {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/Mine.vue'),
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/registry',
    name: 'registry',
    component: () => import('../views/Registry.vue')
  }, {
    path: '/suggestion',
    name: 'suggestion',
    component: () => import('../views/Suggestion.vue'),
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/leavemessage',
    name: 'leavemessage',
    component: () => import('../views/Leavemessage.vue'),
    // meta: {
    //   auth: true
    // },
  }, {
    path: '/buycar',
    name: 'buycar',
    component: () => import('../views/BuyCar.vue')
  }, {
    path: '/blankarticle/:id',
    name: 'blankarticle',
    component: () => import('../views/BlankArticle.vue')
  },{
    path: '/blankactivity/:id',
    name: 'blankactivity',
    component: () => import('../views/BlankActivity.vue')
  },
  
  {
    path: '/myactivity',
    name: 'myactivity',
    component: () => import('../views/MyActivity.vue')
  },
  {
    path: '/myenrolledactivity/:status',
    name: 'myenrolledactivity',
    component: () => import('../views/MyEnrolledActivity.vue')
  },
  
  {
    path: '/mypointshistory',
    name: 'mypointshistory',
    component: () => import('../views/MyPointsHistory.vue')
  },{
    path: '/mysuggestion',
    name: 'mysuggestion',
    component: () => import('../views/MySuggestion.vue')
  },{
    path: '/myexchangeproducts',
    name: 'myexchangeproducts',
    component: () => import('../views/MyExchangeProducts.vue')
  },{
    path: '/myprofile',
    name: 'myprofile',
    component: () => import('../views/MyProfile.vue')
  },
  

]

const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => {
  // localStorage.clear();
  // alert("为特殊案例，清除jwt缓存，clear成功");
  //localStorage['jwt'] = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvTTJyTDVrOEdLRGV6NkwtMk16NElwYkhGd1VVIiwiaXNzIjoiYXV0aDAifQ.iJuawLanz3ORrmtUNmp4A_tp9xVZplQiGR_Dye6AECs";
  if (store.state.jwt != "" && store.state.jwt.length != 0) {
    // alert("第一步：取历史缓存，a）网页state缓存中取到jwt");
    next();
    return;
  } else if(localStorage['jwt'] != null) {
    //  alert("第一步：取历史缓存，b）网页state缓存中没有取到jwt，localstorage取到jwt， 有"+localStorage['jwt']+"end");
    // 因为刷新网页后store中保存的值会清空，所以要用localStorage
    store.commit('getValueFromLocalStorage');
    next();
    return;
  }
  // alert("第一步：取历史缓存，没有取到jwt");

  // let url = location.href;
  var hrefstr, i, pos, parastr, para, tempstr;
  hrefstr = window.location.href;
  // alert(hrefstr);
  pos = hrefstr.indexOf("?");
  parastr = hrefstr.substring(pos + 1);
  para = parastr.split("&");
  tempstr = "";
  let WXAPPID = "wx4ed6a150ffcbcc34"; //"wx4ed6a150ffcbcc34";
  let REDIRECT_URL = "https%3A%2F%2Fwww.gongdiangonghui.cn";//%2Ftest%2Findex.html
  let APIBASEURL = "https://www.gongdiangonghui.cn";

  var code = null;

  for (i = 0; i < para.length; i++) {
    tempstr = para[i];
    pos = tempstr.indexOf("=");

    if (tempstr.substring(0, pos) == "code") {
      code = tempstr.substring(pos + 1);
      //  alert("第二步2 根据code，code =" + code);
    }
  }
  if (code == null) {
    //  alert("第二步1 跳转链接去获取code");
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + WXAPPID + "&redirect_uri=" + REDIRECT_URL + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    return;
  }

  //  alert("code =" + code);
  var xhttp = new XMLHttpRequest();
  xhttp.open("POST", APIBASEURL + "/weixinmember/webPageLogin", false);
  xhttp.setRequestHeader("Content-Type", "application/json");
  xhttp.send(JSON.stringify({ "code": code }));
  var result = xhttp.responseText;

  // document.getElementById("alert").innerHTML=result;
  result = JSON.parse(result);
  //  alert("第三步 跳转链接后，发送Code参数给服务器，取到jwt，jwt=" + result.data.jwt);

  store.commit('setJwt', result.data.jwt);
  // alert("store.state.jwt =" + store.state.jwt);

  axios.post(APIBASEURL + "/member/getSelfInfo", {
    jwt: store.state.jwt
  }).then(function (response) {
    // response = JSON.parse(response);
    // alert("axios /member/getSelfInfo成功，结果是:" + JSON.stringify(response.data));

    if (response.data.code == "400") {
      next('/registry');
    }
    // alert("读取name"+response.data.data.name);
    store.commit('setname', response.data.data.name);
    store.commit('setheadimgurl', response.data.data.headimgurl);
    store.commit('setworkid', response.data.data.workid);
    store.commit('setdepartment', response.data.data.department);
    store.commit('setpersonid', response.data.data.personid);
    store.commit('setphone', response.data.data.phone);
    store.commit('setpoints', response.data.data.points);
    store.commit('setpride', response.data.data.pride);
    store.commit('setcardid', response.data.data.cardid);

  }).catch(function (error) {
    alert("失败，原因是" + error);
  });


  next();
  return;


});


export default router
